import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { Button, TextField, Tooltip } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  getModalidadById,
  postModalidad,
  updateModalidad,
} from "../../../../api/modalidad";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Delete } from "@material-ui/icons";
import Table, { buttonsStyle } from "../../../components/tables/table";
import NumberInputDialog from "../../../components/dialogs/NumberInputDialog";

function getEmptyModalidad() {
  return {
    title: {},
    tooltip: {},
    franRang: [],
  };
}

export default function EditModalidadesPage() {
  const [modalidad, setModalidad] = useState(getEmptyModalidad());
  const [openModal, setOpenModal] = useState(false);
  const modalidadId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!modalidadId) {
      disableLoadingData();
      alertError({ error: null, customMessage: "Could not get modalidad." });
      return history.push("/modalidades");
    }
    getModalidadById(modalidadId)
      .then((res) => {
        if (res.status === 200) {
          setModalidad(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get modalidad." });
        history.push("/modalidades");
      });
  }, [modalidadId, disableLoadingData, history]);

  function saveModalidad() {
    updateModalidad(modalidadId, modalidad)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/modalidades");
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;
      if (!modalidad[element]) modalidad[element] = {};
      let newModalidad = modalidad[element];
      newModalidad[lang] = event.target.value;
      setModalidad({ ...modalidad, [element]: newModalidad });
    } else setModalidad({ ...modalidad, [element]: event.target.value });
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <TextField
          id={`title`}
          label="Title"
          value={(modalidad.title && modalidad.title[lang]) || ""}
          onChange={handleChange("title", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`tooltip`}
          label="Tooltip"
          value={(modalidad.tooltip && modalidad.tooltip[lang]) || ""}
          onChange={handleChange("tooltip", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
      </>
    );
  };
  const deleteFran = (elem) => {
    setModalidad((prevModalidad) => ({
      ...prevModalidad,
      franRang: prevModalidad.franRang.filter((item) => item !== elem),
    }));
  };

  function buttonFormatter(cell) {
    const elem = modalidad.franRang.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              deleteFran(elem);
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "fran", text: "Cantidad", sort: true },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => {
        return { width: `150px` };
      },
    },
  ];
  useEffect(() => {
    console.log(modalidad.franRang);
  }, [modalidad]);

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Edit modalidad"></CardHeader>
          <CardBody>
            <MultilanguageTabBlock
              multilanguageTabContent={renderMultilanguageTabContent}
            />
            {modalidadId === "682dacf6929171d9cfa62380" && (
              <>
                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setOpenModal(true)}
                  >
                    Añadir Cantidad
                  </button>
                </div>

                <Table
                  data={modalidad.franRang}
                  columns={columns}
                  noSearch={true}
                />
              </>
            )}
            <TextField
              id={`caser`}
              label="Caser"
              value={modalidad.caserKey || ""}
              disabled
              onChange={(e) =>
                setModalidad({ ...modalidad, caserKey: e.target.value })
              }
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
            <TextField
              id={`generali`}
              label="Generali"
              value={modalidad.generaliKey || ""}
              disabled
              onChange={(e) =>
                setModalidad({ ...modalidad, generaliKey: e.target.value })
              }
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
            <TextField
              id={`zurich`}
              label="Zurich"
              value={modalidad.zurichKey || ""}
              disabled
              onChange={(e) =>
                setModalidad({ ...modalidad, zurichKey: e.target.value })
              }
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </CardBody>
        </Card>
        <Button
          onClick={() => history.push("/modalidades")}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => saveModalidad()}
          variant="outlined"
          color="primary"
          style={{ marginRight: "20px" }}
        >
          Save modalidad
        </Button>
        <NumberInputDialog
          title={"Añade un nuevo valor de franquicia"}
          open={openModal}
          setOpen={setOpenModal}
          onConfirm={(cantidad) => {
            setModalidad((prevModalidad) => ({
              ...prevModalidad,
              franRang: [
                ...(prevModalidad.franRang || []),
                {
                  active: true,
                  fran: cantidad,
                },
              ],
            }));
          }}
        />
      </>
    );
}
